import { ReactNode, useEffect } from 'react';

/**
 * Shared modal shell — replaces the six hand-rolled overlay/panel pairs. The caller keeps
 * mount/unmount control ({show && <Modal…>}); semantics match the previous inline versions:
 * overlay click closes, panel clicks don't, Escape closes.
 */
export function Modal({ onClose, title, width = 720, align = 'top', children }: {
  onClose: () => void;
  title?: ReactNode;
  width?: number;
  align?: 'top' | 'center';
  children: ReactNode;
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  return (
    <div className={`modal-overlay${align === 'center' ? ' center' : ''}`} onClick={onClose}>
      <div className="modal-panel" role="dialog" aria-modal="true" style={{ maxWidth: width }} onClick={(e) => e.stopPropagation()}>
        {title != null && (
          <div className="modal-head">
            <h3>{title}</h3>
            <button className="modal-close" onClick={onClose} aria-label="关闭 / close">×</button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
